/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import {
  MonitoringIntegrationCommandResponseOutput,
  MonitoringIntegrationDeleteResponseOutput,
  MonitoringIntegrationDetailResponseOutput,
  MonitoringIntegrationPageResponseOutput,
  MonitoringProviderConfigResponseOutput,
} from '../model';
import type {
  ListMonitoringIntegrationsParams,
  MonitoringIntegrationCreate,
  MonitoringIntegrationRetire,
  MonitoringIntegrationUpdate,
  MonitoringIntegrationVersionCommand,
  MonitoringManagementErrorResponse,
} from '../model';

import { validatedFetch } from '../../client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getDeleteMonitoringIntegrationUrl = (integrationId: string) => {
  return `/api/v1/monitoring-integrations/${integrationId}`;
};

export const deleteMonitoringIntegration = async (
  integrationId: string,
  monitoringIntegrationVersionCommand: MonitoringIntegrationVersionCommand,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringIntegrationDeleteResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<MonitoringIntegrationDeleteResponseOutput>(
    getDeleteMonitoringIntegrationUrl(integrationId),
    {
      ...options,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(monitoringIntegrationVersionCommand),
      schema: MonitoringIntegrationDeleteResponseOutput,
    },
  );
};

export const getDeleteMonitoringIntegrationMutationKey = () =>
  ['deleteMonitoringIntegration'] as const;

export const getDeleteMonitoringIntegrationMutationOptions = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMonitoringIntegration>>,
    TError,
    DeleteMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMonitoringIntegration>>,
  TError,
  DeleteMonitoringIntegrationMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteMonitoringIntegrationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMonitoringIntegration>>,
    DeleteMonitoringIntegrationMutationVariables
  > = (props) => {
    const { integrationId, data } = props ?? {};

    return deleteMonitoringIntegration(integrationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMonitoringIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMonitoringIntegration>>
>;
export type DeleteMonitoringIntegrationMutationBody = MonitoringIntegrationVersionCommand;
export type DeleteMonitoringIntegrationMutationError = MonitoringManagementErrorResponse;
export type DeleteMonitoringIntegrationMutationVariables = {
  integrationId: string;
  data: MonitoringIntegrationVersionCommand;
};

export const useDeleteMonitoringIntegration = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMonitoringIntegration>>,
    TError,
    DeleteMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMonitoringIntegration>>,
  TError,
  DeleteMonitoringIntegrationMutationVariables,
  TContext
> => {
  return useMutation(getDeleteMonitoringIntegrationMutationOptions(options));
};
export const getGetMonitoringIntegrationUrl = (integrationId: string) => {
  return `/api/v1/monitoring-integrations/${integrationId}`;
};

export const getMonitoringIntegration = async (
  integrationId: string,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringIntegrationDetailResponseOutput> => {
  return validatedFetch<MonitoringIntegrationDetailResponseOutput>(
    getGetMonitoringIntegrationUrl(integrationId),
    {
      ...options,
      method: 'GET',

      schema: MonitoringIntegrationDetailResponseOutput,
    },
  );
};

export const getGetMonitoringIntegrationQueryKey = (integrationId: string) => {
  return [`/api/v1/monitoring-integrations/${integrationId}`] as const;
};

export const getGetMonitoringIntegrationQueryOptions = <
  TData = Awaited<ReturnType<typeof getMonitoringIntegration>>,
  TError = MonitoringManagementErrorResponse,
>(
  integrationId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMonitoringIntegration>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMonitoringIntegrationQueryKey(integrationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMonitoringIntegration>>> = ({
    signal,
  }) => getMonitoringIntegration(integrationId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: integrationId !== null && integrationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getMonitoringIntegration>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetMonitoringIntegrationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMonitoringIntegration>>
>;
export type GetMonitoringIntegrationQueryError = MonitoringManagementErrorResponse;

export function useGetMonitoringIntegration<
  TData = Awaited<ReturnType<typeof getMonitoringIntegration>>,
  TError = MonitoringManagementErrorResponse,
>(
  integrationId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getMonitoringIntegration>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMonitoringIntegrationQueryOptions(integrationId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateMonitoringIntegrationUrl = (integrationId: string) => {
  return `/api/v1/monitoring-integrations/${integrationId}`;
};

export const updateMonitoringIntegration = async (
  integrationId: string,
  monitoringIntegrationUpdate: MonitoringIntegrationUpdate,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringIntegrationCommandResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<MonitoringIntegrationCommandResponseOutput>(
    getUpdateMonitoringIntegrationUrl(integrationId),
    {
      ...options,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(monitoringIntegrationUpdate),
      schema: MonitoringIntegrationCommandResponseOutput,
    },
  );
};

export const getUpdateMonitoringIntegrationMutationKey = () =>
  ['updateMonitoringIntegration'] as const;

export const getUpdateMonitoringIntegrationMutationOptions = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMonitoringIntegration>>,
    TError,
    UpdateMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMonitoringIntegration>>,
  TError,
  UpdateMonitoringIntegrationMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMonitoringIntegrationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMonitoringIntegration>>,
    UpdateMonitoringIntegrationMutationVariables
  > = (props) => {
    const { integrationId, data } = props ?? {};

    return updateMonitoringIntegration(integrationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMonitoringIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMonitoringIntegration>>
>;
export type UpdateMonitoringIntegrationMutationBody = MonitoringIntegrationUpdate;
export type UpdateMonitoringIntegrationMutationError = MonitoringManagementErrorResponse;
export type UpdateMonitoringIntegrationMutationVariables = {
  integrationId: string;
  data: MonitoringIntegrationUpdate;
};

export const useUpdateMonitoringIntegration = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMonitoringIntegration>>,
    TError,
    UpdateMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMonitoringIntegration>>,
  TError,
  UpdateMonitoringIntegrationMutationVariables,
  TContext
> => {
  return useMutation(getUpdateMonitoringIntegrationMutationOptions(options));
};
export const getListMonitoringIntegrationsUrl = (params?: ListMonitoringIntegrationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/monitoring-integrations?${stringifiedParams}`
    : `/api/v1/monitoring-integrations`;
};

export const listMonitoringIntegrations = async (
  params?: ListMonitoringIntegrationsParams,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringIntegrationPageResponseOutput> => {
  return validatedFetch<MonitoringIntegrationPageResponseOutput>(
    getListMonitoringIntegrationsUrl(params),
    {
      ...options,
      method: 'GET',

      schema: MonitoringIntegrationPageResponseOutput,
    },
  );
};

export const getListMonitoringIntegrationsQueryKey = (
  params?: ListMonitoringIntegrationsParams,
) => {
  return [`/api/v1/monitoring-integrations`, ...(params ? [params] : [])] as const;
};

export const getListMonitoringIntegrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMonitoringIntegrations>>,
  TError = MonitoringManagementErrorResponse,
>(
  params?: ListMonitoringIntegrationsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listMonitoringIntegrations>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMonitoringIntegrationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMonitoringIntegrations>>> = ({
    signal,
  }) => listMonitoringIntegrations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMonitoringIntegrations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMonitoringIntegrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMonitoringIntegrations>>
>;
export type ListMonitoringIntegrationsQueryError = MonitoringManagementErrorResponse;

export function useListMonitoringIntegrations<
  TData = Awaited<ReturnType<typeof listMonitoringIntegrations>>,
  TError = MonitoringManagementErrorResponse,
>(
  params?: ListMonitoringIntegrationsParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listMonitoringIntegrations>>, TError, TData>;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMonitoringIntegrationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateMonitoringIntegrationUrl = () => {
  return `/api/v1/monitoring-integrations`;
};

export const createMonitoringIntegration = async (
  monitoringIntegrationCreate: MonitoringIntegrationCreate,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringIntegrationCommandResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<MonitoringIntegrationCommandResponseOutput>(
    getCreateMonitoringIntegrationUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(monitoringIntegrationCreate),
      schema: MonitoringIntegrationCommandResponseOutput,
    },
  );
};

export const getCreateMonitoringIntegrationMutationKey = () =>
  ['createMonitoringIntegration'] as const;

export const getCreateMonitoringIntegrationMutationOptions = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMonitoringIntegration>>,
    TError,
    CreateMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMonitoringIntegration>>,
  TError,
  CreateMonitoringIntegrationMutationVariables,
  TContext
> => {
  const mutationKey = getCreateMonitoringIntegrationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMonitoringIntegration>>,
    CreateMonitoringIntegrationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createMonitoringIntegration(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMonitoringIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMonitoringIntegration>>
>;
export type CreateMonitoringIntegrationMutationBody = MonitoringIntegrationCreate;
export type CreateMonitoringIntegrationMutationError = MonitoringManagementErrorResponse;
export type CreateMonitoringIntegrationMutationVariables = { data: MonitoringIntegrationCreate };

export const useCreateMonitoringIntegration = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMonitoringIntegration>>,
    TError,
    CreateMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMonitoringIntegration>>,
  TError,
  CreateMonitoringIntegrationMutationVariables,
  TContext
> => {
  return useMutation(getCreateMonitoringIntegrationMutationOptions(options));
};
export const getGetMonitoringProviderConfigurationUrl = (integrationId: string) => {
  return `/api/v1/monitoring-integrations/${integrationId}/provider-configuration`;
};

export const getMonitoringProviderConfiguration = async (
  integrationId: string,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringProviderConfigResponseOutput> => {
  return validatedFetch<MonitoringProviderConfigResponseOutput>(
    getGetMonitoringProviderConfigurationUrl(integrationId),
    {
      ...options,
      method: 'GET',

      schema: MonitoringProviderConfigResponseOutput,
    },
  );
};

export const getGetMonitoringProviderConfigurationQueryKey = (integrationId: string) => {
  return [`/api/v1/monitoring-integrations/${integrationId}/provider-configuration`] as const;
};

export const getGetMonitoringProviderConfigurationQueryOptions = <
  TData = Awaited<ReturnType<typeof getMonitoringProviderConfiguration>>,
  TError = MonitoringManagementErrorResponse,
>(
  integrationId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMonitoringProviderConfiguration>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof validatedFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMonitoringProviderConfigurationQueryKey(integrationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMonitoringProviderConfiguration>>> = ({
    signal,
  }) => getMonitoringProviderConfiguration(integrationId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: integrationId !== null && integrationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMonitoringProviderConfiguration>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMonitoringProviderConfigurationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMonitoringProviderConfiguration>>
>;
export type GetMonitoringProviderConfigurationQueryError = MonitoringManagementErrorResponse;

export function useGetMonitoringProviderConfiguration<
  TData = Awaited<ReturnType<typeof getMonitoringProviderConfiguration>>,
  TError = MonitoringManagementErrorResponse,
>(
  integrationId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMonitoringProviderConfiguration>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof validatedFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMonitoringProviderConfigurationQueryOptions(integrationId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEnableMonitoringIntegrationUrl = (integrationId: string) => {
  return `/api/v1/monitoring-integrations/${integrationId}/enable`;
};

export const enableMonitoringIntegration = async (
  integrationId: string,
  monitoringIntegrationVersionCommand: MonitoringIntegrationVersionCommand,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringIntegrationCommandResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<MonitoringIntegrationCommandResponseOutput>(
    getEnableMonitoringIntegrationUrl(integrationId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(monitoringIntegrationVersionCommand),
      schema: MonitoringIntegrationCommandResponseOutput,
    },
  );
};

export const getEnableMonitoringIntegrationMutationKey = () =>
  ['enableMonitoringIntegration'] as const;

export const getEnableMonitoringIntegrationMutationOptions = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableMonitoringIntegration>>,
    TError,
    EnableMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enableMonitoringIntegration>>,
  TError,
  EnableMonitoringIntegrationMutationVariables,
  TContext
> => {
  const mutationKey = getEnableMonitoringIntegrationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enableMonitoringIntegration>>,
    EnableMonitoringIntegrationMutationVariables
  > = (props) => {
    const { integrationId, data } = props ?? {};

    return enableMonitoringIntegration(integrationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnableMonitoringIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof enableMonitoringIntegration>>
>;
export type EnableMonitoringIntegrationMutationBody = MonitoringIntegrationVersionCommand;
export type EnableMonitoringIntegrationMutationError = MonitoringManagementErrorResponse;
export type EnableMonitoringIntegrationMutationVariables = {
  integrationId: string;
  data: MonitoringIntegrationVersionCommand;
};

export const useEnableMonitoringIntegration = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableMonitoringIntegration>>,
    TError,
    EnableMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof enableMonitoringIntegration>>,
  TError,
  EnableMonitoringIntegrationMutationVariables,
  TContext
> => {
  return useMutation(getEnableMonitoringIntegrationMutationOptions(options));
};
export const getDisableMonitoringIntegrationUrl = (integrationId: string) => {
  return `/api/v1/monitoring-integrations/${integrationId}/disable`;
};

export const disableMonitoringIntegration = async (
  integrationId: string,
  monitoringIntegrationVersionCommand: MonitoringIntegrationVersionCommand,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringIntegrationCommandResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<MonitoringIntegrationCommandResponseOutput>(
    getDisableMonitoringIntegrationUrl(integrationId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(monitoringIntegrationVersionCommand),
      schema: MonitoringIntegrationCommandResponseOutput,
    },
  );
};

export const getDisableMonitoringIntegrationMutationKey = () =>
  ['disableMonitoringIntegration'] as const;

export const getDisableMonitoringIntegrationMutationOptions = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableMonitoringIntegration>>,
    TError,
    DisableMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disableMonitoringIntegration>>,
  TError,
  DisableMonitoringIntegrationMutationVariables,
  TContext
> => {
  const mutationKey = getDisableMonitoringIntegrationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disableMonitoringIntegration>>,
    DisableMonitoringIntegrationMutationVariables
  > = (props) => {
    const { integrationId, data } = props ?? {};

    return disableMonitoringIntegration(integrationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisableMonitoringIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof disableMonitoringIntegration>>
>;
export type DisableMonitoringIntegrationMutationBody = MonitoringIntegrationVersionCommand;
export type DisableMonitoringIntegrationMutationError = MonitoringManagementErrorResponse;
export type DisableMonitoringIntegrationMutationVariables = {
  integrationId: string;
  data: MonitoringIntegrationVersionCommand;
};

export const useDisableMonitoringIntegration = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableMonitoringIntegration>>,
    TError,
    DisableMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disableMonitoringIntegration>>,
  TError,
  DisableMonitoringIntegrationMutationVariables,
  TContext
> => {
  return useMutation(getDisableMonitoringIntegrationMutationOptions(options));
};
export const getRotateMonitoringCredentialUrl = (integrationId: string) => {
  return `/api/v1/monitoring-integrations/${integrationId}/rotate-credential`;
};

export const rotateMonitoringCredential = async (
  integrationId: string,
  monitoringIntegrationVersionCommand: MonitoringIntegrationVersionCommand,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringIntegrationCommandResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<MonitoringIntegrationCommandResponseOutput>(
    getRotateMonitoringCredentialUrl(integrationId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(monitoringIntegrationVersionCommand),
      schema: MonitoringIntegrationCommandResponseOutput,
    },
  );
};

export const getRotateMonitoringCredentialMutationKey = () =>
  ['rotateMonitoringCredential'] as const;

export const getRotateMonitoringCredentialMutationOptions = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rotateMonitoringCredential>>,
    TError,
    RotateMonitoringCredentialMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rotateMonitoringCredential>>,
  TError,
  RotateMonitoringCredentialMutationVariables,
  TContext
> => {
  const mutationKey = getRotateMonitoringCredentialMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rotateMonitoringCredential>>,
    RotateMonitoringCredentialMutationVariables
  > = (props) => {
    const { integrationId, data } = props ?? {};

    return rotateMonitoringCredential(integrationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RotateMonitoringCredentialMutationResult = NonNullable<
  Awaited<ReturnType<typeof rotateMonitoringCredential>>
>;
export type RotateMonitoringCredentialMutationBody = MonitoringIntegrationVersionCommand;
export type RotateMonitoringCredentialMutationError = MonitoringManagementErrorResponse;
export type RotateMonitoringCredentialMutationVariables = {
  integrationId: string;
  data: MonitoringIntegrationVersionCommand;
};

export const useRotateMonitoringCredential = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rotateMonitoringCredential>>,
    TError,
    RotateMonitoringCredentialMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rotateMonitoringCredential>>,
  TError,
  RotateMonitoringCredentialMutationVariables,
  TContext
> => {
  return useMutation(getRotateMonitoringCredentialMutationOptions(options));
};
export const getRetireMonitoringIntegrationUrl = (integrationId: string) => {
  return `/api/v1/monitoring-integrations/${integrationId}/retire`;
};

export const retireMonitoringIntegration = async (
  integrationId: string,
  monitoringIntegrationRetire: MonitoringIntegrationRetire,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<MonitoringIntegrationCommandResponseOutput> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return validatedFetch<MonitoringIntegrationCommandResponseOutput>(
    getRetireMonitoringIntegrationUrl(integrationId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
      body: JSON.stringify(monitoringIntegrationRetire),
      schema: MonitoringIntegrationCommandResponseOutput,
    },
  );
};

export const getRetireMonitoringIntegrationMutationKey = () =>
  ['retireMonitoringIntegration'] as const;

export const getRetireMonitoringIntegrationMutationOptions = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retireMonitoringIntegration>>,
    TError,
    RetireMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retireMonitoringIntegration>>,
  TError,
  RetireMonitoringIntegrationMutationVariables,
  TContext
> => {
  const mutationKey = getRetireMonitoringIntegrationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retireMonitoringIntegration>>,
    RetireMonitoringIntegrationMutationVariables
  > = (props) => {
    const { integrationId, data } = props ?? {};

    return retireMonitoringIntegration(integrationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetireMonitoringIntegrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof retireMonitoringIntegration>>
>;
export type RetireMonitoringIntegrationMutationBody = MonitoringIntegrationRetire;
export type RetireMonitoringIntegrationMutationError = MonitoringManagementErrorResponse;
export type RetireMonitoringIntegrationMutationVariables = {
  integrationId: string;
  data: MonitoringIntegrationRetire;
};

export const useRetireMonitoringIntegration = <
  TError = MonitoringManagementErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retireMonitoringIntegration>>,
    TError,
    RetireMonitoringIntegrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof validatedFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retireMonitoringIntegration>>,
  TError,
  RetireMonitoringIntegrationMutationVariables,
  TContext
> => {
  return useMutation(getRetireMonitoringIntegrationMutationOptions(options));
};
